export default __webpack_public_path__ + "static/media/02 Welcome Screen – 1.164f2f7d.png";